module.exports = __webpack_public_path__ + "static/fbpost-ef6be7b322cbd0fb3598a1fd518b73eb.png";